// user info const
export const AUTH_USER = 'AUTH_USER'
export type AUTH_USER = typeof AUTH_USER
export const SET_USER_AUTH = 'SET_USER_AUTH'
export type SET_USER_AUTH = typeof SET_USER_AUTH
export const REQUEST_USER_INFO = 'REQUEST_USER_INFO'
export type REQUEST_USER_INFO = typeof REQUEST_USER_INFO
export const RECEIVE_USER_INFO = 'RECEIVE_USER_INFO'
export type RECEIVE_USER_INFO = typeof RECEIVE_USER_INFO
export const MODIFY_USER_INFO = 'MODIFY_USER_INFO'
export type MODIFY_USER_INFO = typeof MODIFY_USER_INFO
export const REQUEST_USER_PERM = 'REQUEST_USER_PERM'
export type REQUEST_USER_PERM = typeof REQUEST_USER_PERM
export const RECEIVE_USER_PERM = 'RECEIVE_USER_PERM'
export type RECEIVE_USER_PERM = typeof RECEIVE_USER_PERM

// home const
export const REQUEST_REPORT_LIST = 'REQUEST_REPORT_LIST'
export type REQUEST_REPORT_LIST = typeof REQUEST_REPORT_LIST
export const RECEIVE_REPORT_LIST = 'RECEIVE_REPORT_LIST'
export type RECEIVE_REPORT_LIST = typeof RECEIVE_REPORT_LIST

// bind const
export const REQUEST_BIND_LIST = 'REQUEST_BIND_LIST'
export type REQUEST_BIND_LIST = typeof REQUEST_BIND_LIST
export const RECEIVE_BIND_LIST = 'RECEIVE_BIND_LIST'
export type RECEIVE_BIND_LIST = typeof RECEIVE_BIND_LIST

// auth info const
export const REQUEST_AUTH_INFO = 'REQUEST_AUTH_INFO'
export type REQUEST_AUTH_INFO = typeof REQUEST_AUTH_INFO
export const RECEIVE_AUTH_INFO = 'RECEIVE_AUTH_INFO'
export type RECEIVE_AUTH_INFO = typeof RECEIVE_AUTH_INFO

// config const
export const SET_BM_ENV = 'SET_BM_ENV'
export type SET_BM_ENV = typeof SET_BM_ENV

export const Account_Data_Fields: any = [
    {
        "name": "账户属性",
        "key": "account_props",
        "children": [{
            "name": "广告主ID",
            "key": "adv_user_id",
            "is_numeric": true,
            "select_status": 2,
            "mk_sort": 1
        }, {
            "name": "广告主账户名",
            "key": "adv_account_name",
            "is_numeric": false,
            "select_status": 2,
            "mk_sort": 0
        }, {
            "name": "广告主名称",
            "key": "adv_user_name",
            "is_numeric": false,
            "select_status": 1,
            "mk_sort": 0
        }, {
            "name": "所属代理商",
            "key": "agent_name",
            "is_numeric": false,
            "select_status": 1,
            "mk_sort": 0
        }, {
            "name": "当前余额",
            "key": "balance",
            "is_numeric": false,
            "select_status": 1,
            "mk_sort": 1
        }, {
            "name": "备注",
            "key": "remarks",
            "is_numeric": false,
            "select_status": 1,
            "mk_sort": 0
        }]
    }, 
    {
        "name": "基础数据",
        "key": "basic_data",
        "children": [{
            "name": "展示",
            "key": "impression",
            "is_numeric": true,
            "select_status": 1,
            "mk_sort": 1
        }, {
            "name": "点击",
            "key": "click",
            "is_numeric": false,
            "select_status": 1,
            "mk_sort": 0
        }, {
            "name": "总消费",
            "key": "cost",
            "is_numeric": false,
            "select_status": 1,
            "mk_sort": 0
        }, 
        // {
        //     "name": "现金消耗",
        //     "key": "cash_cost",
        //     "is_numeric": false,
        //     "select_status": 1,
        //     "mk_sort": 0,
        // }, 
        // {
        //     "name": "优惠券消耗",
        //     "key": "coupon_cost",
        //     "is_numeric": false,
        //     "select_status": 1,
        //     "mk_sort": 1
        // }, 
        {
            "name": "点击率",
            "key": "ctr",
            "is_numeric": false,
            "select_status": 1,
            "mk_sort": 0
        }, {
            "name": "点击单价",
            "key": "acp",
            "is_numeric": false,
            "select_status": 1,
            "mk_sort": 1
        }, {
            "name": "千次展现消费",
            "key": "cpm",
            "is_numeric": false,
            "select_status": 1,
            "mk_sort": 0
        }]
    }, 
    {
        "name": "回传转化数据",
        "key": "show_data",
        "children": [{
            "name": "激活",
            "key": "api_app_active",
            "is_numeric": true,
            "select_status": 0,
            "mk_sort": 1
        }, {
            "name": "激活率",
            "key": "api_app_active_rate",
            "is_numeric": true,
            "tips": "计算方式：(激活数/点击数)*100%",
            "select_status": 0,
            "mk_sort": 1
        }, {
            "name": "激活成本",
            "key": "api_app_active_cost",
            "is_numeric": true,
            "tips": "计算方式：总消费/激活数",
            "select_status": 0,
            "mk_sort": 1
        }, {
            "name": "注册",
            "key": "api_app_register",
            "is_numeric": true,
            "select_status": 0,
            "mk_sort": 1
        }, {
            "name": "注册率",
            "key": "api_app_register_rate",
            "is_numeric": true,
            "tips": "计算方式：(注册数/点击数)*100%",
            "select_status": 0,
            "mk_sort": 1
        }, {
            "name": "注册成本",
            "key": "api_app_register_cost",
            "suffix": "%",
            "is_numeric": true,
            "tips": "计算方式：总消费/注册数",
            "select_status": 0,
            "mk_sort": 1
        }, {
            "name": "次留",
            "key": "api_app_retention",
            "is_numeric": true,
            "tips": "计算方式：总消费\/点击数",
            "select_status": 0,
            "mk_sort": 1
        }, {
            "name": "次留率",
            "key": "api_app_retention_rate",
            "is_numeric": true,
            "tips": "计算方式：(次留数/点击数)*100%",
            "select_status": 0,            
            "mk_sort": 1
        }, {
            "name": "次留率(激活)",
            "key": "api_app_retention_active_rate",
            "is_numeric": true,
            "tips": "计算方式：(次留/激活)*100%",
            "select_status": 0,            
            "mk_sort": 1
        }, {
            "name": "次留率(首次拉活)",
            "key": "api_app_retention_lahuo_rate",
            "is_numeric": true,
            "tips": "计算方式：(次留/首次拉活)*100%",
            "select_status": 0,            
            "mk_sort": 1
        }, {
            "name": "次留率(注册)",
            "key": "api_app_retention_register_rate",
            "is_numeric": true,
            "tips": "计算方式：(次留/注册)*100%",
            "select_status": 0,            
            "mk_sort": 1
        }, {
            "name": "次留成本",
            "key": "api_app_retention_cost",
            "is_numeric": true,
            "tips": "计算方式：总消费/次留数",
            "select_status": 0,            
            "mk_sort": 1
        }, {
            "name": "付费",
            "key": "api_app_pay",
            "is_numeric": true,
            "select_status": 0,
            "mk_sort": 1
        }, {
            "name": "付费率",
            "key": "api_app_pay_rate",
            "is_numeric": true,
            "tips": "计算方式：(付费数/点击数)*100%",
            "select_status": 0,            
            "mk_sort": 1
        }, {
            "name": "付费成本",
            "key": "api_app_pay_cost",
            "is_numeric": true,
            "tips": "计算方式：总消费/付费数",
            "select_status": 0,            
            "mk_sort": 1
        }, {
            "name": "付费（回传时间）",
            "key": "api_app_pay_cvr_time",
            "is_numeric": true,
            "select_status": 0,            
            "mk_sort": 1
        }, {
            "name": "付费（回传时间）成本",
            "key": "api_app_pay_cvr_time_cost",
            "is_numeric": true,
            "tips": "计算方式：总消费/付费数（回传时间）",
            "select_status": 0,            
            "mk_sort": 1
        }, {
            "name": "首次拉活",
            "key": "api_app_lahuo",
            "is_numeric": true,
            "select_status": 0,
            "mk_sort": 1
        }, {
            "name": "首次拉活率",
            "key": "api_app_lahuo_rate",
            "is_numeric": true,
            "tips": "计算方式：(首次拉活数/点击数)*100%",
            "select_status": 0,            
            "mk_sort": 1
        }, {
            "name": "首次拉活成本",
            "key": "api_app_lahuo_cost",
            "is_numeric": true,
            "tips": "计算方式：总消费/首次拉活数",
            "select_status": 0,        
            "mk_sort": 1
        }, {
            "name": "关键行为",
            "key": "api_app_keyaction",
            "is_numeric": true,
            "select_status": 0,
            "mk_sort": 1
        }, {
            "name": "关键行为率",
            "key": "api_app_keyaction_rate",
            "is_numeric": true,
            "tips": "计算方式：(关键行为数/点击数)*100%",
            "select_status": 0,
            "mk_sort": 1
        }, {
            "name": "关键行为成本",
            "key": "api_app_keyaction_cost",
            "is_numeric": true,
            "tips": "计算方式：总消费/关键行为数",
            "select_status": 0,
            "mk_sort": 1
        }, {
            "name": "调起小程序",
            "key": "api_jump_miniprogram",
            "is_numeric": true,
            "select_status": 0,
            "mk_sort": 1
        }, {
            "name": "调起小程序率",
            "key": "api_jump_miniprogram_rate",
            "is_numeric": true,
            "tips": "计算方式：(调起小程序数/点击数)*100%",
            "select_status": 0,
            "mk_sort": 1
        }, {
            "name": "调起小程序成本",
            "key": "api_jump_miniprogram_cost",
            "is_numeric": true,
            "tips": "计算方式：总消费/调起小程序数",
            "select_status": 0,
            "mk_sort": 1
        }, 
    ]}
]

export const Account_Data_Fields_White: any = [
    {
        "name": "账户属性",
        "key": "account_props",
        "children": [{
            "name": "广告主ID",
            "key": "adv_user_id",
            "is_numeric": true,
            "select_status": 2,
            "mk_sort": 1
        }, {
            "name": "广告主账户名",
            "key": "adv_account_name",
            "is_numeric": false,
            "select_status": 2,
            "mk_sort": 0
        }, {
            "name": "广告主名称",
            "key": "adv_user_name",
            "is_numeric": false,
            "select_status": 1,
            "mk_sort": 0
        }, {
            "name": "所属代理商",
            "key": "agent_name",
            "is_numeric": false,
            "select_status": 1,
            "mk_sort": 0
        }, {
            "name": "当前余额",
            "key": "balance",
            "is_numeric": false,
            "select_status": 1,
            "mk_sort": 1
        }, {
            "name": "备注",
            "key": "remarks",
            "is_numeric": false,
            "select_status": 1,
            "mk_sort": 0
        }]
    }, 
    {
        "name": "基础数据",
        "key": "basic_data",
        "children": [{
            "name": "展示",
            "key": "impression",
            "is_numeric": true,
            "select_status": 1,
            "mk_sort": 1
        }, {
            "name": "点击",
            "key": "click",
            "is_numeric": false,
            "select_status": 1,
            "mk_sort": 0
        }, {
            "name": "总消费",
            "key": "cost",
            "is_numeric": false,
            "select_status": 1,
            "mk_sort": 0
        }, 
        {
            "name": "现金消耗",
            "key": "cash_cost",
            "is_numeric": false,
            "select_status": 1,
            "mk_sort": 0,
        }, 
        {
            "name": "优惠券消耗",
            "key": "coupon_cost",
            "is_numeric": false,
            "select_status": 1,
            "mk_sort": 1
        }, 
        {
            "name": "点击率",
            "key": "ctr",
            "is_numeric": false,
            "select_status": 1,
            "mk_sort": 0
        }, {
            "name": "点击单价",
            "key": "acp",
            "is_numeric": false,
            "select_status": 1,
            "mk_sort": 1
        }, {
            "name": "千次展现消费",
            "key": "cpm",
            "is_numeric": false,
            "select_status": 1,
            "mk_sort": 0
        }]
    }, 
    {
        "name": "回传转化数据",
        "key": "show_data",
        "children": [{
            "name": "激活",
            "key": "api_app_active",
            "is_numeric": true,
            "select_status": 0,
            "mk_sort": 1
        }, {
            "name": "激活率",
            "key": "api_app_active_rate",
            "is_numeric": true,
            "tips": "计算方式：(激活数/点击数)*100%",
            "select_status": 0,
            "mk_sort": 1
        }, {
            "name": "激活成本",
            "key": "api_app_active_cost",
            "is_numeric": true,
            "tips": "计算方式：总消费/激活数",
            "select_status": 0,
            "mk_sort": 1
        }, {
            "name": "注册",
            "key": "api_app_register",
            "is_numeric": true,
            "select_status": 0,
            "mk_sort": 1
        }, {
            "name": "注册率",
            "key": "api_app_register_rate",
            "is_numeric": true,
            "tips": "计算方式：(注册数/点击数)*100%",
            "select_status": 0,
            "mk_sort": 1
        }, {
            "name": "注册成本",
            "key": "api_app_register_cost",
            "suffix": "%",
            "is_numeric": true,
            "tips": "计算方式：总消费/注册数",
            "select_status": 0,
            "mk_sort": 1
        }, {
            "name": "次留",
            "key": "api_app_retention",
            "is_numeric": true,
            "tips": "计算方式：总消费\/点击数",
            "select_status": 0,
            "mk_sort": 1
        }, {
            "name": "次留率",
            "key": "api_app_retention_rate",
            "is_numeric": true,
            "tips": "计算方式：(次留数/点击数)*100%",
            "select_status": 0,            
            "mk_sort": 1
        }, {
            "name": "次留率(激活)",
            "key": "api_app_retention_active_rate",
            "is_numeric": true,
            "tips": "计算方式：(次留/激活)*100%",
            "select_status": 0,            
            "mk_sort": 1
        }, {
            "name": "次留率(首次拉活)",
            "key": "api_app_retention_lahuo_rate",
            "is_numeric": true,
            "tips": "计算方式：(次留/首次拉活)*100%",
            "select_status": 0,            
            "mk_sort": 1
        }, {
            "name": "次留率(注册)",
            "key": "api_app_retention_register_rate",
            "is_numeric": true,
            "tips": "计算方式：(次留/注册)*100%",
            "select_status": 0,            
            "mk_sort": 1
        }, {
            "name": "次留成本",
            "key": "api_app_retention_cost",
            "is_numeric": true,
            "tips": "计算方式：总消费/次留数",
            "select_status": 0,            
            "mk_sort": 1
        }, {
            "name": "付费",
            "key": "api_app_pay",
            "is_numeric": true,
            "select_status": 0,
            "mk_sort": 1
        }, {
            "name": "付费率",
            "key": "api_app_pay_rate",
            "is_numeric": true,
            "tips": "计算方式：(付费数/点击数)*100%",
            "select_status": 0,            
            "mk_sort": 1
        }, {
            "name": "付费成本",
            "key": "api_app_pay_cost",
            "is_numeric": true,
            "tips": "计算方式：总消费/付费数",
            "select_status": 0,            
            "mk_sort": 1
        }, {
            "name": "付费（回传时间）",
            "key": "api_app_pay_cvr_time",
            "is_numeric": true,
            "select_status": 0,            
            "mk_sort": 1
        }, {
            "name": "付费（回传时间）成本",
            "key": "api_app_pay_cvr_time_cost",
            "is_numeric": true,
            "tips": "计算方式：总消费/付费数（回传时间）",
            "select_status": 0,            
            "mk_sort": 1
        }, {
            "name": "首次拉活",
            "key": "api_app_lahuo",
            "is_numeric": true,
            "select_status": 0,
            "mk_sort": 1
        }, {
            "name": "首次拉活率",
            "key": "api_app_lahuo_rate",
            "is_numeric": true,
            "tips": "计算方式：(首次拉活数/点击数)*100%",
            "select_status": 0,            
            "mk_sort": 1
        }, {
            "name": "首次拉活成本",
            "key": "api_app_lahuo_cost",
            "is_numeric": true,
            "tips": "计算方式：总消费/首次拉活数",
            "select_status": 0,        
            "mk_sort": 1
        }, {
            "name": "关键行为",
            "key": "api_app_keyaction",
            "is_numeric": true,
            "select_status": 0,
            "mk_sort": 1
        }, {
            "name": "关键行为率",
            "key": "api_app_keyaction_rate",
            "is_numeric": true,
            "tips": "计算方式：(关键行为数/点击数)*100%",
            "select_status": 0,
            "mk_sort": 1
        }, {
            "name": "关键行为成本",
            "key": "api_app_keyaction_cost",
            "is_numeric": true,
            "tips": "计算方式：总消费/关键行为数",
            "select_status": 0,
            "mk_sort": 1
        }, {
            "name": "调起小程序",
            "key": "api_jump_miniprogram",
            "is_numeric": true,
            "select_status": 0,
            "mk_sort": 1
        }, {
            "name": "调起小程序率",
            "key": "api_jump_miniprogram_rate",
            "is_numeric": true,
            "tips": "计算方式：(调起小程序数/点击数)*100%",
            "select_status": 0,
            "mk_sort": 1
        }, {
            "name": "调起小程序成本",
            "key": "api_jump_miniprogram_cost",
            "is_numeric": true,
            "tips": "计算方式：总消费/调起小程序数",
            "select_status": 0,
            "mk_sort": 1
        }, 
    ]}
]


// WEBPACK FOOTER //
// ./src/constants/index.tsx